<!-- 
出荷先カードを表示する
-->

<template>
  <div>
    <v-card
      elevation="5"
      :class="{ 'card-warning': cardColor == 20 }"
      class="ma-4"
    >
      <v-card-title class="custom-card-title">出荷先</v-card-title>
      <v-card-text>
        <v-row
          align="center"
          v-for="(destination, index) in destinations"
          :key="destination.key"
        >
          <v-col>
            <!-- カード -->
            <destination-card-child
              :destination="destination"
              @on-click-remove="remove(index)"
              @change-destination="changeDestination($event, index)"
              ref="destination_card_child"
            ></destination-card-child>
          </v-col>
        </v-row>
        <!-- 追加ボタン -->
        <v-row align="center">
          <v-col align="center">
            <v-btn slot="append" icon outlined color="primary" @click="append">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-col align="right">
          <v-card-text class="custom-card-text"
            >合計出荷重量：{{ total }}kg</v-card-text
          >
          <v-card-text class="custom-card-text"
            >合計殻付き個数：{{ numTotal }}個</v-card-text
          >
        </v-col>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DestinationCardChild from "..//record-update/append-destination-card-base.vue";
const CARD_COLOR_NOMAL = 10;
const CARD_COLOR_WARNING = 20;
// const CARD_COLOR_ERROR = 30;

export default {
  name: "destination-card-parent",
  components: {
    "destination-card-child": DestinationCardChild,
  },
  props: {},
  watch: {},
  computed: {
    /**
     * formDataの入力が不正ならtrueを返す
     */
    hasErrorFormData() {
      for (let i = 0; i < this.destinations.length; i++) {
        if (this.destinations[i].hasErrorFormData) {
          return true;
        }
      }
      return false;
    },
    cardColor: function () {
      // カードがない場合
      if (this.destinations.length == 0) {
        return CARD_COLOR_WARNING;
      }

      let childCardColor = [];
      for (let i = 0; i < this.destinations.length; i++) {
        childCardColor.push(this.destinations[i].cardColor);
      }
      // 警告を含む場合
      if (childCardColor.includes(CARD_COLOR_WARNING)) {
        return CARD_COLOR_WARNING;
      }

      // 警告を含まない場合
      return CARD_COLOR_NOMAL;
    },
    total: function () {
      var res = Number(0);
      for (let i = 0; i < this.destinations.length; i++) {
        res += Number(this.destinations[i].subtotal);
      }
      return res;
    },
    numTotal: function () {
      var res = Number(0);
      for (let i = 0; i < this.destinations.length; i++) {
        res += Number(this.destinations[i].numtotal);
      }
      if (isNaN(res)) res = 0;
      return res;
    },
  },
  data() {
    this.weightKG = 0;
    this.weightCan = 0;
    this.numSSize = 0;
    this.numMSize = 0;
    this.numLSize = 0;
    this.num2LSize = 0;
    this.doublingRate = 0;
    this.subtotal = 0;
    this.numtotal = 0;
    return {
      destinations: [],
    };
  },
  methods: {
    /**
     * カードを追加する
     */
    append() {
      this.setDestinations({
        destinationName: "",
        weightKG: "",
        weightCan: "",
        numSSize: "",
        numMSize: "",
        numLSize: "",
        num2LSize: "",
        doublingRate: 1,  // 初期値は通常（二倍体）を選択する
      });
    },
    /**
     * 値を指定してカードを追加する
     * value
     *  destinationName: 出荷先,
     *  weightKG: 重量(kg),
     *  weightCan: 缶数(20kg/缶),
     *  numSSize: Sサイズ個数(個),
     *  numMSize: Mサイズ個数(個),
     *  numLSize: Lサイズ個数(個),
     *  num2LSize: 2Lサイズ個数(個),
     *  doublingRate: 区分(1:通常（二倍体）2:三倍体),
     */
    setDestinations(value) {
      let weightKG = value.weightKG;
      let weightCan = value.weightCan;
      let numSSize = value.numSSize;
      let numMSize = value.numMSize;
      let numLSize = value.numLSize;
      let num2LSize = value.num2LSize;
      let doublingRate = value.doublingRate;
      // -1の場合未入力とする
      if (weightKG == -1) {
        weightKG = "";
      }
      if (weightCan == -1) {
        weightCan = "";
      }
      if (numSSize == -1) {
        numSSize = "";
      }
      if (numMSize == -1) {
        numMSize = "";
      }
      if (numLSize == -1) {
        numLSize = "";
      }
      if (num2LSize == -1) {
        num2LSize = "";
      }

      // 区分未定義の場合、デフォルト通常（二倍体）とする。
      if (doublingRate == undefined) {
        doublingRate = 1;
      }

      // 小計を計算
      const subtotal = weightKG + weightCan * 20;
      const numtotal = (numSSize ? parseInt(numSSize) : 0) + (numMSize ? parseInt(numMSize) : 0) + (numLSize ? parseInt(numLSize) : 0) + (num2LSize ? parseInt(num2LSize) : 0) + 0;
      console.log(Number(numSSize ? parseInt(numSSize) : 0));
      console.log(numtotal);
      let newDestination = {
        destinationName: value.destinationName,
        weightKG: weightKG,
        weightCan: weightCan,
        numSSize: numSSize,
        numMSize: numMSize,
        numLSize: numLSize,
        num2LSize: num2LSize,
        doublingRate: doublingRate,
        subtotal: subtotal,
        numtotal: numtotal,
        cardColor: this.setCardColor(value.destinationName, subtotal),
      };
      this.destinations.push(newDestination);
    },
    /**
     * カード追加時のカード色を設定する
     */
    setCardColor(name, subtotal) {
      if (name !== "" && subtotal !== "" && subtotal > 0) {
        return CARD_COLOR_NOMAL;
      } else {
        return CARD_COLOR_WARNING;
      }
    },
    /**
     * カードを削除する
     */
    async remove(index) {
      if (index < this.destinations.length) {
        await this.destinations.splice(index, 1);
      }
      // カード削除後、子コンポーネントでpropsの値を参照し直す
      for (let i = index; i < this.destinations.length; i++) {
        this.$refs.destination_card_child[i].reload();
      }
    },
    /**
     * 重量変更時、値を受け取りさらに上位に返す
     */
    changeDestination: function (args, index) {
      this.destinations.splice(index, 1, args);
      this.$emit("on-change-destination", args, index);
    },
    /**
     * 出荷先の入力値を返却する
     */
    getDestinations() {
      let res = [];
      for (let i = 0; i < this.destinations.length; i++) {
        let item = {
          destinationName: this.destinations[i].destinationName,
          weightKG: this.destinations[i].weightKG,
          weightCan: this.destinations[i].weightCan,
          numSSize: this.destinations[i].numSSize,
          numMSize: this.destinations[i].numMSize,
          numLSize: this.destinations[i].numLSize,
          num2LSize: this.destinations[i].num2LSize,
          doublingRate: this.destinations[i].doublingRate,
        };
        res.push(item);
      }
      return res;
    },
    /**
     * エラーがあればtrueを返す
     */
    hasError() {},
  },
};
</script>

<style scoped>
.card-warning {
  background-color: #fff8dc;
}
.card-error {
  background-color: #ffdbe2;
}
.custom-card-title {
  font-size: 32px;
  color: #333;
  line-height: 1.5;
}
.custom-card-text {
  font-size: 16px;
  line-height: 1.3;
}
</style>
